import { t } from "@web-monorepo/i18n/macro";
import DisplayPairShareResult from "src/pods/pairshare/components/receiver/PairShareResult";
import RemotePairShareResult from "src/pods/pairshare/components/sender/PairShareResult";
import AppRemoteCard from "src/shared/components/AppRemoteCard";
import SlideNavigation from "./SlideNavigation";
import type { RemoteSlideProps, Slide } from "./types";
import { resolveText, type SlideText } from "./text";
import styles from "./PairShareSlide.module.css";

export const PairShareSlide = (text: SlideText): Slide => {
  return {
    display: () => <DisplayPairShareResult question={{ text: resolveText(text) }} />,
    remote: ({ next }: RemoteSlideProps) => (
      <div className={styles.frame}>
        {/* `title` required: AppRemoteCard always renders an <h1>, so
            omitting it produces an empty-heading axe violation. */}
        <AppRemoteCard variant="pairshare" title={t`Pair share`}>
          <RemotePairShareResult question={{ text: resolveText(text) }} />
        </AppRemoteCard>
        <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
      </div>
    ),
  };
};
